module.exports = __webpack_public_path__ + "img/account.a0f2b43a.svg";